import React, { useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import ToggleSwitch from '../../Models/ToggleSwitch';
const AddSlider = () => {
  const {SetNotification}= useStateContext() ; 
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const [file_, setFile] = useState(null);
  const [Active, setActive] = useState(1);
  const [lang,setLang]= useState("EN") ; 
  const [sending , setIsSending] = useState(false) ; 

 
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true) ; 
    const payload = {
      title: titleRef.current.value,
   
    };
console.log(payload);
await AxiosClient.post('/slides', payload).then((response) =>{
  if (response.status ==201) 
  {
    SetNotification('File added successfully' , "success");
    navigate(-1);
  }
 
  
}).catch((error)=>{
  if (error.response && error.response.data && error.response.data.message) {
    const errorMessage = error.response.data.message;
    SetNotification(errorMessage, 'danger');
  } else {
    SetNotification('An error occurred while Add File.', 'danger');
  }


});
setIsSending(false) ; 
}

  return (
    <div className="m-4">
      
      
     
      
      <form  className="form-group"  > 
         <h5> Title </h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter title" ref={titleRef}  />
        </div>
      
      

       
         
       

        <hr className="border-gray-300 my-4" />

       

{sending ? <h1>sending ... </h1> :  <button onClick={handleSubmit} className="btn btn-primary">
          Submit
        </button>}
       
      </form>
    </div>
  );
};

export default AddSlider;